import { LIST_REQUIRED_STATUSES } from "../../required-values";

export default {
    NETWORK_ERROR: {
        TITLE: "Σφάλμα δικτύου",
        MESSAGE: "Ελέγξτε τη σύνδεσή σας στο Διαδίκτυο και βεβαιωθείτε ότι είναι καλή. Εάν φαίνεται εντάξει, περιμένετε μερικά λεπτά, κλείστε αυτό το μήνυμα και δοκιμάστε ξανά (μην ανανεώσετε διαφορετικά μπορεί να χάσετε αυτό που εισαγάγατε)."
    },
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: "Λείπει το πεδίο για τη διεύθυνση email",
        MESSAGE: "Προσθέστε τουλάχιστον 1 πεδίο για διεύθυνση email!"
    },
    INVALID_INPUT_ERROR: {
        INNER_HTML: `
         <h2>Λείπει ένα υποχρεωτικό πεδίο ή ένα πεδίο δεν είναι έγκυρο.</h2>
         <h4 class="error-message main-message">
         Παρακαλώ ελέγξτε τη φόρμα για μηνύματα σφάλματος!
         </h4>
         <h5>{0}</h5>
         `
    },
    LOGIN_MISSING_EMAIL_ERROR: {
        TITLE: 'Η διεύθυνση ηλεκτρονικού ταχυδρομείου λείπει',
        MESSAGE: 'Παρακαλώ εισάγετε τη διεύθυνση email!'
    },
    LOGIN_MISSING_PASSWORD_ERROR: {
        TITLE: "Λείπει ο κωδικός πρόσβασης",
        MESSAGE: 'Παρακαλώ εισάγετε τον κωδικό πρόσβασης!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Λείπει η ώρα κράτησης',
        MESSAGE: 'Παρακαλώ προσθέστε την ώρα κράτησης (Ώρα έναρξης και ώρα λήξης)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: "Ένα έγγραφο δεν έχει υπογραφεί",
        MESSAGE: "Διαβάστε τη φόρμα για μηνύματα σφάλματος και υπογράψτε όλα τα έγγραφα!"
    },
    MISSING_EVALUATION_ERROR: {
        TITLE: "Μια αξιολόγηση δεν έχει ολοκληρωθεί",
        MESSAGE: 'Ελέγξτε τη φόρμα για μηνύματα σφάλματος και ολοκληρώστε όλη την αξιολόγηση!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: "Ένα πεδίο εισαγωγής δεν είναι έγκυρο",
        MESSAGE: "Υπάρχει ένα πεδίο εισαγωγής που δεν είναι έγκυρο"
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: "Δεν υπάρχει πεδίο για τον κατασκευαστή",
        MESSAGE: "Προσθέστε τουλάχιστον ένα πεδίο!"
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: "Δεν είναι δυνατή η χρήση της ίδιας επιλογής μεταξύ {0} και {1}",
        MESSAGE: "Αποεπιλέξτε τις επιλογές {2} σε {0} ή {1}"
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: "Προσθέστε περισσότερα {0}!",
        MESSAGE: "Πρέπει να έχετε τουλάχιστον {1} {0}"
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Λείπει η εμπειρία',
        MESSAGE: 'Πρέπει να έχετε τουλάχιστον 1 εμπειρία.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: "Λείπουν καταστάσεις",
        MESSAGE: `${LIST_REQUIRED_STATUSES.join(" και ")} είναι υποχρεωτικές καταστάσεις`
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: "Οι καταστάσεις είναι διπλότυπες",
        MESSAGE: "Υπάρχουν ορισμένες καταστάσεις που είναι διπλότυπες"
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: "Πολλά πεδία που χρησιμοποιούν το ίδιο μοντέλο",
        MESSAGE: 'Υπάρχει ένα μοντέλο που έχει εκχωρηθεί σε τουλάχιστον 2 πεδία'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: "Οι καταστάσεις είναι διπλότυπες",
        MESSAGE: "Υπάρχουν ορισμένα αντικείμενα που είναι διπλότυπα"
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: "Ο τύπος εργοδότη είναι διπλότυπος",
        MESSAGE: "Υπάρχουν ορισμένοι τύποι εργοδότη που είναι διπλότυποι"
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: "Ο τύπος υποψηφίου είναι διπλότυπος",
        MESSAGE: "Υπάρχουν ορισμένοι υποψήφιοι τύποι που είναι διπλότυποι"
    },
    DUPLICATE_JOB_TYPE_ERROR: {
        TITLE: "Οι τύποι εργασίας είναι διπλότυποι",
        MESSAGE: "Υπάρχουν ορισμένοι τύποι εργασιών που είναι διπλότυποι"
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: "Λυπούμαστε, αυτός ο τύπος αρχείου δεν είναι έγκυρος!",
        MESSAGE: 'Παρακαλώ ανεβάστε μια εικόνα PNG ή JPG.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: "Λυπούμαστε, αυτός ο τύπος αρχείου δεν είναι έγκυρος!",
        MESSAGE: 'Παρακαλώ ανεβάστε ένα αρχείο DOC ή DOCX ή PDF.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: "Το αρχείο είναι κενό!",
        MESSAGE: "Μεταφορτώστε ένα μη κενό αρχείο"
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: "Πολύ μεγάλο αρχείο!",
        MESSAGE: 'Παρακαλώ μεταφορτώστε ένα αρχείο με μέγεθος κάτω από το μέγιστο μέγεθος μεταφόρτωσης.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Μη έγκυρο αρχείο',
        MESSAGE: 'Μη έγκυρο αρχείο εισαγωγής'
    },
    MISSING_RESUME_ERROR: {
        TITLE: "Λείπει το επαγγελματικό σας βιογραφικό φύλαξης παιδιών",
        MESSAGE: 'Παρακαλώ ανεβάστε το επαγγελματικό σας βιογραφικό φύλαξης παιδιών'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: "Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης",
        MESSAGE: "Παρακαλώ αλλάξτε ημερομηνία έναρξης ή ημερομηνία λήξης"
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: "Η ώρα λήξης πρέπει να είναι μετά την ώρα έναρξης",
        MESSAGE: "Παρακαλώ αλλάξτε ώρα έναρξης ή ώρα λήξης"
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: "Οι κρατήσεις πρέπει να είναι τουλάχιστον {0} ώρες.",
        MESSAGE: "Παρακαλώ αλλάξτε ώρα έναρξης ή ώρα λήξης"
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: "Λείπει η φωτογραφία του προφίλ σας",
        MESSAGE: 'Παρακαλώ ανεβάστε μια πρόσφατη φωτογραφία σας!'
    },
    NO_TEXT_SELECT: {
        TITLE: "Δεν έχει επιλεγεί κείμενο",
        MESSAGE: "Παρακαλώ επιλέξτε κάποιο κείμενο"
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Η αίτησή σας υποβλήθηκε! ΑΛΛΑ',
        MESSAGE: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία των αναφορών σας. Μπορείτε να μας τα στείλετε μέσω email; Ευχαριστώ!'
    },
    SUBMIT_ERROR: {
        TITLE: "Αποτυχία υποβολής της αίτησής σας",
        MESSAGE: "Παρουσιάστηκε σφάλμα κατά την επεξεργασία της αίτησής σας"
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Λείπει στοιχείο στη λίστα κατάστασης',
        MESSAGE: "Απαιτείται η κατάσταση {0}"
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: "Υπάρχει μια ημιτελής ενότητα",
        MESSAGE: 'Η ενότητα {0} δεν είναι ολοκληρωμένη. Ενημερώστε αυτήν την ενότητα'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν.'
    },
    INVALID_PHONE_NUMBER_ERROR: {
        TITLE: "Μη έγκυρος αριθμός τηλεφώνου",
        MESSAGE: "Ο αριθμός τηλεφώνου {0} δεν είναι έγκυρος. Διορθώστε τον"
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: "Δεν είναι δυνατή η εύρεση κοντινών υποψηφίων",
        MESSAGE: 'Λείπει μια πλήρης διεύθυνση από την εργασία.Για αναζήτηση υποψηφίων Επεξεργαστείτε την εργασία και συμπληρώστε τα στοιχεία διεύθυνσης που λείπουν'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: "Το πρόγραμμα δημιουργίας προφίλ χρησιμοποιείται",
        MESSAGE: 'Το εργαλείο δημιουργίας προφίλ χρησιμοποιείται από το πρόγραμμα δημιουργίας προφίλ {0}.\n' +
            'Καταργήστε πρώτα αυτό το πρόγραμμα δημιουργίας προφίλ'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: "Λείπει μια υπογραφή",
        MESSAGE: "Πληκτρολογήστε το όνομά σας για υπογραφή"
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: "Λείπει ένα υποχρεωτικό πεδίο",
        MESSAGE: 'Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία (Ελέγξτε τα πεδία με κόκκινο περίγραμμα)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: `
         <h2>Φαίνεται ότι είστε ήδη στο σύστημά μας!</h2>
         <h4 class="error-message main-message">
         Παρακαλούμε <a href='{0}/login/{1}'>συνδεθείτε στον πίνακα ελέγχου σας</a> για να συνεχίσετε ή επικοινωνήστε μαζί μας εάν έχετε ερωτήσεις. Ευχαριστώ!
         </h4>
         `
    },
    FORCE_LOGOUT_ERROR_DIALOG: {
        TITLE: "Έχετε αποσυνδεθεί!",
        MESSAGE: "Λυπούμαστε, αποσυνδεθήκατε μέσω σύνδεσης σε αυτόν τον λογαριασμό από άλλη συσκευή.",
    },
    WEEK_AVAILABILITY_BLOCK_END_TIME_BEFORE_START_TIME_ERROR: {
        TITLE: "Η ώρα λήξης πρέπει να είναι μετά την ώρα έναρξης",
        MESSAGE: "Αλλάξτε την ώρα έναρξης ή λήξης του μπλοκ {0} από {1}"
    },
    WEEK_AVAILABILITY_DURATION_TOO_SHORT_ERROR: {
        TITLE: "Ο αποκλεισμός πρέπει να είναι τουλάχιστον {0} ώρες.",
        MESSAGE: "Παρακαλώ αλλάξτε την ώρα έναρξης ή λήξης του μπλοκ {1} από {2}"
    },
    WEEK_AVAILABILITY_EMPTY_REQUIRED_FIELD_ERROR: {
        TITLE: "Κενό υποχρεωτικό πεδίο",
        MESSAGE: "Παρακαλώ συμπληρώστε και την ώρα έναρξης και την ώρα λήξης του μπλοκ {0} από {1}"
    },
    PAYMENT_INFORMATION_REQUIRED: {
        TITLE: "Απαιτούνται στοιχεία πληρωμής",
        MESSAGE: "Παρακαλώ εισάγετε τα στοιχεία πληρωμής"
    },
    INVALID_PAYMENT_INFORMATION: {
        TITLE: "Μη έγκυρα στοιχεία πληρωμής",
        MESSAGE: "Ενημερώστε τα στοιχεία πληρωμής: {0}"
    },
    LIST_INPUT_CONTAINS_BLANK: {
        TITLE: "{0} περιέχει κενή τιμή",
        MESSAGE: "Παρακαλώ αφαιρέστε το κενό {0}"
    },
    DUPLICATE_HEADER_IMPORT_CSV: {
        TITLE: "Υπάρχουν μερικές διπλότυπες κεφαλίδες.",
        MESSAGE: "Λίστα διπλότυπων κεφαλίδων: {0}.\nΕάν εισαχθούν οι διπλότυπες κεφαλίδες, τα αντίστοιχα πεδία ενδέχεται να μην εισαχθούν"
    },
    CANNOT_EDIT_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Δεν είναι δυνατή η επεξεργασία της κράτησης",
        MESSAGE: "Λυπούμαστε, η αλλαγή δεν μπορεί να γίνει λιγότερο από {0} ώρες πριν από την έναρξη μιας εργασίας. Εάν χρειάζεστε μια αλλαγή, επικοινωνήστε απευθείας μαζί μας. Ευχαριστούμε!"
    },
    CANNOT_ADD_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Δεν είναι δυνατή η προσθήκη της κράτησης",
        MESSAGE: "Λυπούμαστε, δεν μπορείτε να κάνετε κράτηση λιγότερο από {0} ώρες πριν από την έναρξη μιας εργασίας. Εάν το χρειάζεστε πραγματικά, επικοινωνήστε μαζί μας απευθείας. Ευχαριστούμε!"
    },
    PAYMENT_FIELD_REQUIRED_IN_APPLICATION_FORM: {
        TITLE: "Απαιτείται πεδίο πληρωμής",
        MESSAGE: "Προσθέστε πεδίο πληρωμής για να μπορείτε να χρεώνετε τον χρήστη κατά την υποβολή της αίτησης"
    },
    MISSING_NUMBER_OF_ROWS: {
        TITLE: "Παρακαλώ καθορίστε τον αριθμό των σειρών για μερική εισαγωγή"
    },
    SCHEDULE_CONFLICT_CANDIDATE_ERROR_DIALOG: {
        TITLE: "Προγραμματισμός διένεξης",
        MESSAGE: "Έχετε ήδη ανατεθεί σε άλλη εργασία κατά τη διάρκεια αυτής της περιόδου"
    },
    JOB_NO_LONGER_AVAILABLE_ERROR_DIALOG: {
        TITLE: "Αυτή η εργασία δεν είναι πλέον διαθέσιμη",
    },
    CLIENT_CONFIRM_INCORRECT_PASSWORD: {
        TITLE: "Λανθασμένος κωδικός πρόσβασης",
        MESSAGE: "Απέτυχε η έγκριση της ώρας εισόδου/εξόδου του ρολογιού. Ο κωδικός πρόσβασης πελάτη είναι λάθος"
    },
    HAS_MISSING_SECTION_BUILDER_ERROR_DIALOG: {
        TITLE: "Λείπει ένα εργαλείο δημιουργίας ενότητας",
        MESSAGE: "Το εργαλείο δημιουργίας προφίλ εισήχθη με επιτυχία. Ωστόσο, λείπει μια επιλογή του εργαλείου δημιουργίας ενότητας (ετικέτα πεδίου: {0}). Επεξεργαστείτε το εργαλείο δημιουργίας για να το διορθώσετε"
    },
    CLOCK_OUT_CLIENT_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Ο πελάτης δεν εισήγαγε στοιχεία πληρωμής. Θα επεξεργαστούμε την πληρωμή αργότερα.\n" +
            " Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας."
    },
    CLOCK_OUT_CANDIDATE_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Ο υποψήφιος δεν εισήγαγε στοιχεία πληρωμής. Θα επεξεργαστούμε την πληρωμή αργότερα. Εισαγάγετε τα στοιχεία πληρωμής σας για να πληρωθείτε μέσω Stripe\n" +
            " Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας."
    },
    CLOCK_OUT_MISSING_PAYMENT_INFORMATION: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Λείπουν στοιχεία πληρωμής. Θα επεξεργαστούμε την πληρωμή αργότερα.\n" +
            " Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας."
    },
    SCHEDULE_TIME_IN_PAST: {
        TITLE: "Η καθορισμένη ώρα είναι παρελθόν. Επιλέξτε άλλη ώρα"
    },
    ACTION_MISSING_DATE_FIELD: {
        TITLE: "Παρακαλώ επιλέξτε ημερομηνία"
    },
    APPLICATION_FORM_DUPLICATED_PHONE: {
        TITLE: "Προειδοποίηση!",
        MESSAGE: "Ο αριθμός τηλεφώνου σας είναι ήδη στο σύστημα, έχετε συνεργαστεί μαζί μας στο παρελθόν; Εάν ναι, επικοινωνήστε μαζί μας και μπορούμε να σας βοηθήσουμε να αποκτήσετε πρόσβαση στον υπάρχοντα λογαριασμό σας!"
    },
    APPLICATION_FORM_DUPLICATED_EMAIL: {
        TITLE: "Προειδοποίηση!",
        MESSAGE: "Η διεύθυνση email σας είναι ήδη στο σύστημα, έχετε συνεργαστεί μαζί μας στο παρελθόν; Εάν ναι, επικοινωνήστε μαζί μας και μπορούμε να σας βοηθήσουμε να αποκτήσετε πρόσβαση στον υπάρχοντα λογαριασμό σας!"
    },
    INVALID_AMOUNT_ERROR: {
        TITLE: "Μη έγκυρο ποσό"
    },
    NON_NUMBER_INPUT_ERROR: {
        TITLE: "Παρακαλώ εισάγετε έναν αριθμό"
    },
    SEND_EMAIL_TOO_LONG_DURATION_ERROR_DIALOG: {
        TITLE: "Ο προγραμματισμός για περισσότερες από 8 ώρες δεν υποστηρίζεται"
    },
    APPLICATION_FORM_USER_SUBMITTED: {
        TITLE: "Ο χρήστης υπέβαλε τη φόρμα αίτησης"
    },
    APPLICATION_FORM_USER_INCORRECT_USER_ID: {
        TITLE: "Λανθασμένο αναγνωριστικό χρήστη",
        MESSAGE: "Επικοινωνήστε με την εταιρεία σας για να λάβετε τη σωστή διεύθυνση URL"
    },
    NO_JOB_POSTER_ERROR_DIALOG: {
        TITLE: "Η εργασία δεν έχει πληροφορίες αφίσας"
    },
    RETURNING_APPLICANT_EMAIL_NOT_FOUND: {
        TITLE: "Η διεύθυνση ηλεκτρονικού ταχυδρομείου δεν βρέθηκε",
        MESSAGE: "Λυπούμαστε, δεν μπορέσαμε να το βρούμε στο σύστημά μας. Δοκιμάστε ένα διαφορετικό email ή επικοινωνήστε μαζί μας εάν έχετε ερωτήσεις"
    },
    RETURNING_APPLICANT_INCORRECT_CODE: {
        TITLE: "Εσφαλμένος κωδικός",
        MESSAGE: "Ο εισαγόμενος κωδικός επαλήθευσης είναι λανθασμένος. Δοκιμάστε ξανά αργότερα"
    },
    SHIFT_JOB_REPORT_IS_REQUIRED: {
        TITLE: "Απαιτείται αναφορά εργασίας αλλαγής",
        MESSAGE: "Παρακαλώ υποβάλετε αναφορά εργασίας βάρδιας πριν από το ρολόι"
    },
    TIMEOFF_REQUEST_ON_ASSIGNED_DATES_ERROR: {
        TITLE: "Αποτυχία υποβολής αιτήματος χρονικού ορίου",
        MESSAGE: "Έχετε ανατεθεί σε μια εργασία στο {0}! Επικοινωνήστε απευθείας μαζί μας εάν χρειάζεστε ελεύθερο χρόνο."
    },
    NOT_ALLOW_MOVE_FIELD_ERROR_DIALOG: {
        TITLE: "Δεν είναι δυνατή η μετακίνηση αυτού του πεδίου",
        MESSAGE: "Αυτό είναι ένα ειδικό πεδίο και δεν μπορεί να μετακινηθεί στη φόρμα αίτησης"
    },
    INVALID_LINK_ERROR_DIALOG: {
        TITLE: "Ο σύνδεσμος δεν είναι έγκυρος"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/error-dialog/el.js